import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import * as R from 'ramda';
import { createSelector } from 'reselect';
import { branch, renderComponent, compose } from 'recompose';
import Link from 'components/general/Link/Link';
import Article from 'components/general/Article/Article';
import ArticleSkeleton from 'components/general/Article/ArticleSkeleton';
import getCurrentPermalink from 'selectors/getCurrentPermalink';
import getMarketingUrl from 'selectors/getMarketingUrl';
import prependAssetRoot from 'utils/prependAssetRoot';
import { selectors } from './../ducks/article.duck';

const getAlertData = createSelector(
  selectors.data,
  getCurrentPermalink,
  getMarketingUrl,
  (data, permalink, marketingUrl) => {

    if (!data || R.isEmpty(data)) return {};

    return R.applySpec({
      title: R.prop('title'),
      summary: R.prop('synopsis'),
      permalink: R.always(permalink),
      share: R.T,
      category: R.always({
        title: 'Articles',
        to: { type: 'ARTICLES_INDEX' },
      }),
      author: {
        name: R.path(['editor', 'name']),
        id: R.path(['editor', 'id']),
        photo: R.pipe(
          R.path(['editor', 'photo']),
          prependAssetRoot,
        ),
      },
      created: R.prop('date'),
      meta: R.always([{
        id: 'geography',
        title: 'Geography',
        info: (
          R.pipe(
            R.pathOr([], ['geography']),
            R.addIndex(R.map)((region, i)=> (
              <Fragment>
                {i > 0 ? ', ' : ''}
                <Link
                  to={{
                    type: 'ARTICLES_INDEX',
                    query: {
                      regions: [ R.prop('slug', region) ],
                    },
                  }}
                >
                  {R.prop('title', region)}
                </Link>
              </Fragment>
            )),
          )(data)
        ),
      }]),
      matrixBlocks: R.path(['body', '0', 'blocks']),
      marketingUrl: R.always(marketingUrl),
    })(data);
  },
);

const mapStateToProps = state => ({
  loading: selectors.loading(state),
  ...getAlertData(state),
});

// @todo: Full article skeleton
const AlertArticle = compose(
  connect(mapStateToProps),
  branch(
    R.pathEq(['loading', 'state'], 'LOADING'),
    renderComponent(ArticleSkeleton),
  ),
)(Article);

export default AlertArticle;
